import React from "react";
import { TRUST_BAR_PARTNERS } from "../lib/partnerBranding";
import { useCountry } from "../contexts/CountryContext";
import { getHomeContent } from "../data/homeContent";

/** OPTRA's partners are the same in every region; a pack may only reword a country-specific link. */
export default function TrustBar() {
  const { country } = useCountry();
  const { partnerOverrides } = getHomeContent(country).trustBar;
  const partners = TRUST_BAR_PARTNERS.map((partner) => ({ ...partner, ...(partnerOverrides[partner.name] || {}) }));
  return (
    <section
      aria-label="Partner trust bar"
      className="relative z-20 w-full px-4 md:px-6"
      style={{
        paddingTop: "2.25rem",
        paddingBottom: "3.25rem",
      }}
    >
      <div
        className="mx-auto flex w-full max-w-6xl flex-col items-center justify-center gap-5"
        style={{
          borderTop: "1px solid rgba(148, 163, 184, 0.22)",
          borderBottom: "1px solid rgba(148, 163, 184, 0.16)",
          paddingTop: "1.6rem",
          paddingBottom: "1.6rem",
        }}
      >
        <p
          className="text-center"
          style={{
            margin: 0,
            color: "#6B7280",
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            fontWeight: 300,
            fontSize: "0.8rem",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            lineHeight: 1.5,
          }}
        >
          Collaborating with Established Ecosystem Partners
        </p>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-10">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center"
              aria-label={partner.ariaLabel}
            >
              <img
                src={partner.logoSrc}
                alt={partner.logoAlt}
                className={partner.logoClassName}
                loading="lazy"
              />
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}
